import { CodeNameModel } from 'components/common/types';
import CollapsibleList from 'lib/CollapsibleList';
import CollapsibleListStatsHeader from 'lib/CollapsibleList/CollapsibleListStatsHeader';
import SelectOption from 'lib/SelectOption';
import { shouldDisplayCategoryClearAll } from 'components/pages/Planner/PlannerSections/FiltersContent/utils';
import { TagsOptionsListProps } from './TagsOptionsList.types';

const TagsOptionsList: React.FC<TagsOptionsListProps> = ({
  filteredOptions,
  selectedOptions,
  openCategories,
  sortDirection,
  includedOptions,
  excludedOptions,
  onSort,
  onToggleCategory,
  setSelectedOptions,
  getNumberOfFilteredOptions,
  isOptionSelected,
  isOptionIncluded,
  onOptionIncludeExcludeChange,
  onCategoryIncludeAll,
  onCategoryExcludeAll,
  getCategoryIncludeState,
}) => {
  return (
    <>
      {Object.keys(filteredOptions).map((category) => {
        return (
          <CollapsibleList
            label={category}
            isSortVisible
            onSort={onSort}
            isClearAllVisible={shouldDisplayCategoryClearAll(selectedOptions, category)}
            onClearAll={() => setSelectedOptions((prev) => prev.filter((tag) => tag.category !== category))}
            isOpen={openCategories.includes(category)}
            category={category}
            onToggle={onToggleCategory}
            sortDir={sortDirection}
            key={`tag-category-${category}`}
            groupIncludeState={getCategoryIncludeState(category)}
            onGroupInclude={onCategoryIncludeAll}
            onGroupExclude={onCategoryExcludeAll}
            headerComponent={
              <CollapsibleListStatsHeader
                available={filteredOptions[category].length}
                included={getNumberOfFilteredOptions(category, includedOptions)}
                excluded={getNumberOfFilteredOptions(category, excludedOptions)}
              />
            }
          >
            {filteredOptions[category].map((subOption) => {
              const isSelected = isOptionSelected(subOption.code, category);

              return (
                <SelectOption
                  value={{
                    code: subOption.code,
                    name: subOption.name,
                    include: isSelected ? isOptionIncluded(subOption.code, category) : undefined,
                  }}
                  key={`select-category-${subOption.code}`}
                  isSelected={isSelected}
                  isDisabled={false}
                  isMultiple
                  hasCheckbox={false}
                  isIncludeExcludeAlwaysVisible
                  onIncludeExcludeChange={(value: CodeNameModel) =>
                    onOptionIncludeExcludeChange({
                      ...value,
                      category,
                    })
                  }
                  classNames="!m-0"
                >
                  {subOption.name}
                </SelectOption>
              );
            })}
          </CollapsibleList>
        );
      })}
    </>
  );
};

export default TagsOptionsList;
